// Types used by entire app
import type { InitialDataQueryQuery } from '@/generated/graphql';

/** Gets all value types of another type, reverse of keyof */
export type ValueOf<T> = T[keyof T];

/** Makes all nested objects partial, does not work on arrays */
export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

// Used for setting up other types
export type NotNullCheckoutSession = NonNullable<
  InitialDataQueryQuery['checkoutSession']
>;

export type NotNullLandingIWC = NonNullable<
  Weasley.InitialData['landingIWCData']
>;

export type NotNullCart = NonNullable<NotNullCheckoutSession['cart']>;

export type NullableCheckoutSession = Partial<
  InitialDataQueryQuery['checkoutSession']
>;

export type OptionalKey<T, K extends keyof T> = Omit<T, K> & { K?: T[K] };

export const APP_MODE = {
  GUEST: 'guest',
  SIGNUP: 'signup',
} as const;

export type AppMode = ValueOf<typeof APP_MODE>;

export type GenericObjectType<T = any> = {
  [key: string | number | symbol]: T;
};

export type FiTypes = 'bank' | 'card' | 'bnpl';

export enum FormTabs {
  Bank = 'bank-tab',
  Card = 'card-tab',
  BNPL = 'bnpl-tab',
}

export type SessionFlags = NonNullable<NotNullCheckoutSession['flags']>;

export type InputOnChange = (e: React.ChangeEvent<HTMLInputElement>) => void;
export type InputOnChangeWithValueAndMeta = (
  e: React.ChangeEvent<HTMLInputElement>,
  value: string,
  oldValue: string,
  meta: GenericObjectType,
) => void;
export type InputOnBlurChange = (e: React.FocusEvent<HTMLInputElement>) => void;
// They are the same for now, just made a new type in case that changes one day
export type InputOnFocus = InputOnBlurChange;
export type ButtonClickEvent = (
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
) => void;

export type ReactComponentsChangeHandler = (
  e: React.ChangeEvent<HTMLInputElement>,
  newValue: string,
  oldValue: string,
  meta: GenericObjectType,
) => void;

export type ButtonType = 'button' | 'reset' | 'submit';

export type HandlersTypes = {
  blurHandler: InputOnBlurChange;
  changeHandler: InputOnChange;
  focusHandler: InputOnBlurChange;
};

export type Noop = () => void;

export type PageLevelAlertTypes = 'info' | 'success' | 'warning' | 'error';

export type AddressType = 'residential' | 'billing' | 'shipping';

export type LogLevel = 'info' | 'warn' | 'error';

export type AddressNormalizationPageType =
  | 'shipToBilling'
  | 'billing'
  | 'shipping';

// TODO: Generate this from weasley app config in severus
export interface WeasleyAppConfig {
  configSource: string;
  healthCheck: {
    ASSERTION_THRESHOLDS: {
      rootElWidthOrHeight: number;
      visibleRootDepth: number;
      visibleTextCount: number;
    };
    ASSERTION_WEIGHTS: {
      rootElDimensionsZero: number;
      visibleRootDepth: number;
      visibleTextCount: number;
    };
    ENABLED: boolean;
    LIMIT_HEALTHECK_TO_SINGLE_RUN: boolean;
    SEND_SCORECARD_DETAILS_TO_CAL_FPTI: boolean;
    THRESHOLD_FATAL: number;
  };
}

export enum ALERT {
  DANGER_ALERT_ERROR = 'DANGER_ALERT_ERROR',
  LIMIT_ALERT_ERROR = 'LIMIT_ALERT_ERROR',
  SUCCESS_ALERT = 'SUCCESS_ALERT',
  INTERNAL_SERVICE_ERROR = 'INTERNAL_SERVICE_ERROR',
}

export enum REBRAND_BUTTON_TREATMENT {
  Control = 'Ctrl_FEATURE_PAYSHEET_CTA_BUTTON_COLOR',
  Treatment1 = 'Trmt_FEATURE_PAYSHEET_CTA_BUTTON_COLOR_1',
  Treatment2 = 'Trmt_FEATURE_PAYSHEET_CTA_BUTTON_COLOR_2',
  Treatment3 = 'Trmt_FEATURE_PAYSHEET_CTA_BUTTON_COLOR_3',
}

export enum BUTTON_COLOR_TREATMENT {
  /** Legacy button color */
  Control = 'Ctrl_FEATURE_CTA_BUTTON_COLOR',
  /** Black button color */
  Treatment1 = 'Trmt_FEATURE_CTA_BUTTON_COLOR_1',
  /** Light blue button color */
  Treatment2 = 'Trmt_FEATURE_CTA_BUTTON_COLOR_2',
  /** New dark blue button color */
  Treatment3 = 'Trmt_FEATURE_CTA_BUTTON_COLOR_3',
}

export enum InstallmentType {
  MCI = 'MCI',
  SHARED_IC2B = 'SHARED_IC2B',
  FULL_IC2B = 'FULL_IC2B',
}
